import { Injectable } from '@angular/core';
import { FlightStatusDate } from '@modules/flight-status/flight-status-date';
import { textChangeRangeIsUnchanged } from 'typescript';

@Injectable({
  providedIn: 'root'
})
export class FlightStatusDateService {

  dateFormat: any;
  today: Date;
  yesterday: Date;
  tomorrow: Date;
  afterTomorrow: Date;
  beforeYesterday: Date;

  constructor() {
    this.today = new Date();
    this.beforeYesterday = new Date(); this.beforeYesterday.setDate(this.today.getDate() - 2);
    this.yesterday = new Date(); this.yesterday.setDate(this.today.getDate() - 1);
    this.tomorrow = new Date(); this.tomorrow.setDate(this.today.getDate() + 1);
    this.afterTomorrow = new Date(); this.afterTomorrow.setDate(this.today.getDate() + 2);
  }

  getDates(dateFormat): Array<FlightStatusDate>{
    const formattedDates: Array<FlightStatusDate> = [];
    this.dateFormat = dateFormat;
 
    formattedDates.push(this.generateDate(this.beforeYesterday),
        this.generateDate(this.yesterday),
        this.generateDate(this.today),
        this.generateDate(this.tomorrow),
        this.generateDate(this.afterTomorrow));
    return formattedDates;
  }

  generateDate(date): FlightStatusDate {
    return {
      'item': this.formatDate(date, 'item'),
      'value': this.formatDate(date, 'value'),
      'default': date === this.today ? true : false
    }
  }

  formatDate(date, key) {
    const flightStatusDate = this.dateFormat[key];
    if (flightStatusDate === undefined) {
      return
    }

    const format = flightStatusDate.dateFormat;
    const dayOfWeek = date.getDay();
    const dayOfMonth = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const monthName = flightStatusDate.monthNames[month];
    const dayName = flightStatusDate.dayNames[dayOfWeek];

    return format.replace(/{d}/g, dayOfMonth).replace(/{EEEE}/g, dayName).replace(/{MMMM}/g, monthName).replace(/{YYYY}/g, year);
  }
}
